import { useTonConnectUI, useTonWallet } from "@tonconnect/ui-react";
import { useCallback } from "react";
import { isMobile } from "../../utils/AppConstants";

interface currentWallet {
  aboutUrl: string;
  appName: string;
  bridgeUrl: string;
  deepLink: string;
  embedded: boolean;
  imageUrl: string;
  injected: boolean;
  jsBridgeKey: string;
  name: string;
  platforms: string[];
  tondns: string;
  universalLink: string;
}

const useOpenUniversalLink = () => {
  const wallet = useTonWallet();
  const [tonConnectUI] = useTonConnectUI();

  const openUniversalLink = useCallback(async () => {
    if (
      isMobile &&
      wallet?.provider !== "injected" &&
      (wallet?.device.platform === "iphone" ||
        wallet?.device.platform === "ipad" ||
        wallet?.device.platform === "android")
    ) {
      const wallets = await tonConnectUI.getWallets();
      const currentWallet = wallets.find(
        (item) => item.name === wallet?.device.appName
      ) as currentWallet;

      if (currentWallet && currentWallet.universalLink) {
        window.open(
          currentWallet.universalLink,
          "_parent",
          "noopener,noreferrer"
        );
      }
    }
  }, [wallet, tonConnectUI]);

  return { openUniversalLink };
};

export default useOpenUniversalLink;
